import { StoreLocalStorage } from "./store-local";

export class StoreSessionStorage extends StoreLocalStorage {
    constructor(Vue, options) {
        super(Vue, options);
        this.store = window.sessionStorage;
    }
}